import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { MemberItemEntity } from '../../../../ui/components/app-member-list/member-item.entity';
import { MemberListEntity } from '../../../../ui/components/app-member-list/member-list.entity';

export enum ConsumerType {
	User = 'user',
	Group = 'group',
}

@Injectable()
export class ConsumerListProvider {
	private readonly userList: MemberListEntity;
	private readonly groupList: MemberListEntity;

	public constructor() {
		this.userList = MemberListEntity.build([
			{
				field: 'login',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.login:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: false,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 0,
			},
			{
				field: 'firstName',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.firstname:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 1,
			},
			{
				field: 'lastName',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.lastname:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 2,
			},
			{
				field: 'mail',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.email:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 3,
			},
			{
				field: 'creationDate',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.creationDate:`,
				type: 'date',
				isSearchable: false,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 4,
			},
			{
				field: 'updateDate',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.updateDate:`,
				type: 'date',
				isSearchable: false,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 5,
			},
		]);
		this.groupList = MemberListEntity.build([
			{
				field: 'name',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.name:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 0,
			},
			{
				field: 'description',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 1,
			},
			{
				field: 'creationDate',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.creationDate:`,
				type: 'date',
				isSearchable: false,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 2,
			},
			{
				field: 'updateDate',
				alias: $localize`:i18n=@@expositions.consumers.mapping.availableConsumers.list.column.updateDate:`,
				type: 'date',
				isSearchable: false,
				isFilterable: true,
				canBeReordered: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 3,
			},
		]);
	}

	public getList(type: ConsumerType): MemberListEntity {
		return type === 'user' ? this.userList : this.groupList;
	}

	public setListElements(
		type: ConsumerType,
		elements: Map<string, MemberItemEntity>,
		total: number
	): MemberListEntity {
		if (type === ConsumerType.User) {
			return this.userList.setMemberListData(elements, total);
		}
		return this.groupList.setMemberListData(elements, total);
	}
}
